<form *ngIf="form != null" class="form-container" [formGroup]="form" autocomplete="off">
    <table mat-table [dataSource]="dataSource" *ngIf="data != null; else elseBlock">
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef class="centerContent"><b>Name</b></th>
            <td mat-cell *matCellDef="let element; let i = index" class="tableField" [formGroup]="element">
                <mat-form-field appearance="outline" class="fullwidth">
                    <input matInput autoComplete="off" formControlName="name" title="{{uniqueNameTitle}}"
                        (ngModelChange)="uniqueValidation($event, i)">
                </mat-form-field>
                <div *ngIf="showTMNameWarning(i)" class="validation-status">
                    {{uniqueNameTitle}}
                </div>
            </td>
        </ng-container>

        <ng-container matColumnDef="ac">
            <th mat-header-cell *matHeaderCellDef class="centerContent"><b>Airport Connection</b></th>
            <td mat-cell *matCellDef="let element" class="tableField" [formGroup]="element">
                <mat-checkbox formControlName="airportConnection"></mat-checkbox>
            </td>
        </ng-container>

        <ng-container matColumnDef="hc">
            <th mat-header-cell *matHeaderCellDef class="centerContent"><b>Harbour Connection</b></th>
            <td mat-cell *matCellDef="let element" class="tableField" [formGroup]="element">
                <mat-checkbox formControlName="harbourConnection"></mat-checkbox>
            </td>
        </ng-container>

        <ng-container matColumnDef="seasons">
            <th mat-header-cell *matHeaderCellDef class="centerContent"><b>Seasons</b></th>
            <td mat-cell *matCellDef="let element" class="tableField" [formGroup]="element">
                <mat-form-field>
                    <mat-select formControlName="seasonIds" matTooltip="{{getSeasonsToolTipData(element)}}" multiple>
                        <mat-option *ngFor="let season of seasons" [value]="season.id">{{season.name}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </td>
        </ng-container>

        <ng-container matColumnDef="transportmode">
            <th mat-header-cell *matHeaderCellDef class="centerContent"><b>Transport Modes</b></th>
            <td mat-cell *matCellDef="let element" class="tableField" [formGroup]="element">
                <mat-form-field>
                    <mat-select formControlName="transportModeIds" matTooltip="{{getTransportModeToolTipData(element)}}"
                        multiple>
                        <mat-option *ngFor="let transportMode of transportModes" [value]="transportMode.id">
                            {{transportMode.name}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </td>
        </ng-container>

        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="centerContent"><b>Luggage Amount Values</b></th>
            <td mat-cell *matCellDef="let element" class="tableField">
                <mat-icon class="openCell" title="Edit Luggage Amount Values" (click)="openEditor(element)">forward
                </mat-icon>
            </td>
        </ng-container>

        <ng-container matColumnDef="markAsDelete">
            <th mat-header-cell *matHeaderCellDef class="centerContent"><b>Mark As Delete</b></th>
            <td mat-cell *matCellDef="let element; let i = index" class="tableField" [formGroup]="element">
                <mat-icon class="openCell" title="Remove TravelMix" (click)="removeTravelMix(element, i)">delete
                </mat-icon>

            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="openProject"></tr>
    </table>
    <ng-template #elseBlock>
        <h1 style="text-align:center;">{{errorMessage}}</h1>
    </ng-template>
</form>